import useBudgetingService from 'domain/organization/serviceCatalog/budgets/budgetingService';
import { CreateForm, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useServiceCatalogId } from 'domain/organization/serviceCatalog/useServiceCatalogId';
import { useMessageService, ErrorMessage, WarningMessage } from 'framework/ui/Message';
import { HTTP } from 'framework/api';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import ServiceCostsStructureForm from 'domain/organization/serviceCatalog/budgets/structure/Create/ServiceCostsStructureForm';

const CreateServiceBudgetStructure = ({ onCancel, afterSubmit }: any) => {
  const id = useServiceCatalogId();
  const { createStructure, getValidationSchema } = useBudgetingService();
  const { addMessage } = useMessageService();

  const handleErrorsOnSubmit = (submitErrors: any) => {
    switch (submitErrors.status) {
      case HTTP.NOT_FOUND:
        addMessage(
          new WarningMessage('The budget for this service has not yet been created. Please try again in a minute.'),
        );
        break;
      default:
        addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <CreateForm
      submitFormFunc={async req => createStructure(id, req)}
      afterSubmit={afterSubmit}
      handleErrorsOnSubmit={handleErrorsOnSubmit}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        categories: [],
        objectives: [],
      }}
    >
      <CreateTimelineItemLayout onCancel={onCancel}>
        <ServiceCostsStructureForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateServiceBudgetStructure;
